import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChange,
  SimpleChanges
} from '@angular/core';
import { GroupTypeUI } from '../../models/group-types.model';
import { IterationUI } from '../../models/iteration.model';
import { IterationListEntryComponent } from '../iteration-list-entry/iteration-list-entry.component';



export class IterationTreeComponent {

   iterationList: IterationUI[] = [];
   collection: any;
   witGroup: GroupTypeUI;
   showTree: string = '';
   showCompleted: string = '';
   context: 'list' | 'board'; // 'list' or 'board'

   readonly onEditIteration = new EventEmitter<IterationUI>();
   readonly onCloseIteration = new EventEmitter<IterationUI>();
   readonly onCreateIteration = new EventEmitter<IterationUI>();

  editIteration(iteration) {
    this.onEditIteration.emit(iteration);
  }

  closeIteration(iteration) {
    this.onCloseIteration.emit(iteration);
  }

  createIteration(iteration) {
    this.onCreateIteration.emit(iteration);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'iteration-tree',
    templateUrl: './iteration-tree.component.html'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'iterationList': [{ type: Input },],
'collection': [{ type: Input },],
'witGroup': [{ type: Input },],
'showTree': [{ type: Input },],
'showCompleted': [{ type: Input },],
'context': [{ type: Input },],
'onEditIteration': [{ type: Output },],
'onCloseIteration': [{ type: Output },],
'onCreateIteration': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
